import { useQuery } from "@tanstack/react-query";
import { getMe } from "../api/user";

/** The signed-in user's profile (id, email, first/last name). */
export function useMe() {
  return useQuery({
    queryKey: ["me"],
    queryFn: getMe,
    staleTime: 5 * 60 * 1000, // profile rarely changes underneath us
  });
}
